var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size,"viewBox":"0 -960 960 960"}},[_c('path',{attrs:{"d":"M271-120 80-311l192-192 42 42-120 120h646v60H194l119 119-42 42Zm418-337-42-42 \n        119-119H120v-60h646L646-798l42-42 192 192-191 191Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }